export default "__VITE_ASSET__2a256934__"